import axiosInstance from "../api/axios";

/* ---------------- Referral vendors (reward partners) ---------------- */
export const searchReferralVendors = (body) => axiosInstance.post(`/referral-vendors/search`, body || {});
export const createReferralVendor = (body) => axiosInstance.post(`/referral-vendors`, body);
export const updateReferralVendor = (id, body) => axiosInstance.put(`/referral-vendors/${id}`, body);
export const deleteReferralVendor = (id) => axiosInstance.delete(`/referral-vendors/${id}`);

/* ---------------- Referral vendor categories (broad reward categories) ---------------- */
export const listReferralVendorCategories = (onlyActive = false) =>
  axiosInstance.get(`/referral-vendor-categories`, { params: { onlyActive } });
export const createReferralVendorCategory = (body) => axiosInstance.post(`/referral-vendor-categories`, body);
export const updateReferralVendorCategory = (id, body) => axiosInstance.put(`/referral-vendor-categories/${id}`, body);
export const deleteReferralVendorCategory = (id) => axiosInstance.delete(`/referral-vendor-categories/${id}`);

/* ---------------- Referral rewards + CP commissions ---------------- */
export const listReferralRewards = (params) => axiosInstance.get(`/admin/referral-rewards`, { params });
// Mint a CP-routed referral reward (commission economics entered manually by BV admin).
export const createReferralReward = (body) => axiosInstance.post(`/admin/referral-rewards`, body);
// Edit a pending reward's commission / cut / amount / agent.
export const updateReferralReward = (id, body) => axiosInstance.put(`/admin/referral-rewards/${id}`, body);
// Validate (cpPaid=true -> REDEEMABLE) or reject (false -> PENDING_PAYMENT) a CP's remittance.
export const setReferralRewardCpPaid = (id, body) =>
  axiosInstance.patch(`/admin/referral-rewards/${id}/cp-paid`, body);
// Which CP a referral from this buyer would route to (prefill for the reward form).
export const resolveReferrerCp = (referrerUserId, projectId) =>
  axiosInstance.get(`/admin/referrals/${referrerUserId}/cp`, { params: { projectId } });

/* ---------------- Vendor-voucher redemption fulfillment (v3_65) ---------------- */
export const listReferralRedemptions = (params) => axiosInstance.get(`/admin/referral-redemptions`, { params });
export const fulfillReferralRedemption = (id) =>
  axiosInstance.patch(`/admin/referral-redemptions/${id}/fulfill`);

/* ---------------- Referrals queue + routing (v3_66) ---------------- */
export const listReferrals = (params) => axiosInstance.get(`/admin/referrals`, { params });
export const referralsByReferrer = () => axiosInstance.get(`/admin/referrals/by-referrer`);
export const assignReferralCp = (id, agentId) =>
  axiosInstance.patch(`/admin/referrals/${id}/assign-cp`, { agentId });
// Materialize an interior lead (user+login+customer_user under the BV owner) so a BV-project sale can be created.
export const prepareInteriorSale = (id) => axiosInstance.post(`/admin/referrals/${id}/prepare-sale`);
export const listChannelPartners = () => axiosInstance.get(`/admin/channel-partners`);
